/**
 * アプリケーション共通バリデーションメッセージテンプレート
 */

/** 必須入力 */
export const MSG_REQUIRED = (field: string) => `${field}を入力してください。`;

/** 最大文字数超過 */
export const MSG_MAX_LENGTH = (field: string, max: number) =>
  `${field}は${max}文字以内で入力してください。`;

/** 最小文字数不足 */
export const MSG_MIN_LENGTH = (field: string, min: number) =>
  `${field}は${min}文字以上で入力してください。`;

/** 半角英数字記号のみ */
export const MSG_PATTERN_ALPHANUMERIC_SYMBOL = (field: string) =>
  `${field}は半角英数字記号で入力してください。`;

/** 日時フォーマット不正 */
export const MSG_INVALID_DATETIME_FORMAT = (field: string) =>
  `${field}の形式が正しくありません。（yyyy-MM-dd'T'HH:mm:ss）`;

/** 最小値（以上） */
export const MSG_MIN_VALUE = (field: string, min: number) =>
  `${field}は${min}以上で入力してください。`;

/** 整数のみ */
export const MSG_INTEGER = (field: string) => `${field}は整数で入力してください。`;
